import Vue from 'vue';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

const vm = new Vue({
  router,
  render: (h) => h(App),
  methods: {
    log1(args) {
      const res = [];
      for (let i = 0; i < args.length; i += 1) {
        if (typeof (args[i]) === 'object') {
          try {
            // res[i] = JSON.parse(JSON.stringify(args[i]));
            res.push(JSON.parse(JSON.stringify(args[i])));
          } catch (e) {
            console.error(e);
          }
        }
      }
      return res;
    }
  },
});

vm.$mount('#app');
